import { loadStripe } from '@stripe/stripe-js'
import type { Stripe } from '@stripe/stripe-js'
import { env } from '@/lib/env'

// Client-side Stripe instance
let stripePromise: Promise<Stripe | null>

export const getStripe = () => {
  if (!stripePromise) {
    const publishableKey = env('NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY')

    if (!publishableKey) {
      throw new Error('Stripe publishable key is not configured')
    }

    stripePromise = loadStripe(publishableKey)
  }
  return stripePromise
}

// Helper function to format amount for Stripe (convert dollars to cents)
export const formatAmountForStripe = (amount: number): number => {
  return Math.round(amount * 100)
}

// Helper function to format amount for display (convert cents to dollars)
export const formatAmountFromStripe = (amount: number): number => {
  return amount / 100
}
